// extracted by mini-css-extract-plugin
module.exports = {"Container":"Configs_Container__1e72M","Options":"Configs_Options__1vAmz","Card":"Configs_Card__2sJ9o"};